import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { SP_WIDTH } from '../config/constants'
import DesktopApp from './desktop/App'
import MobileApp from './mobile/App'
import 'utils/axios'
import { QueryClient, QueryClientProvider } from 'react-query'

function AppWithResponsive() {
  const client = new QueryClient()

  const isDesktop = useMediaQuery({
    query: `(min-width: ${SP_WIDTH + 1}px)`,
  })

  return (
    <>
      <QueryClientProvider client={client}>{isDesktop ? <DesktopApp /> : <MobileApp />}</QueryClientProvider>
    </>
  )
}

export default AppWithResponsive
